<template>
  <div>
    SettingView
  </div>
</template>

<script>

export default {
  name: 'SettingView',

  components: {
  },

  data() {
    return {
    }
  },

  methods: {
  }
};
</script>
